import { createNavLink } from "./navigation-utils.js";
import getNavigationState from "./navigation-state.js";

export default function initSidebarNav() {
  console.log("INIT Sidebar Nav RUNNING");

  const sidebar = document.querySelector(".sz-sidebar__nav");
  if (!sidebar) return;

  const state = getNavigationState();
  if (!state?.current) return;

  const ul = document.createElement("ul");
  ul.className = "sz-sidebar__list";

  // -----------------------------------------
  // 1. Add current page (as heading item)
  // -----------------------------------------

  const currentLi = document.createElement("li");
  currentLi.className = "sz-sidebar__item";

  /* const currentLink = document.createElement("a");
  currentLink.href = state.current.url;
  currentLink.textContent = state.current.label;
  currentLink.className = "sz-sidebar__link is-current is-active";
  currentLink.setAttribute("aria-current", "page"); */
  const currentLink = createNavLink({
    url: state.current.url,
    label: state.current.label,
    className: "sz-sidebar__link is-current is-active",
    current: true,
  });

  currentLi.appendChild(currentLink);
  ul.appendChild(currentLi);

  // -----------------------------------------
  // 2. Add children (preferred)
  // fallback to siblings if no children
  // -----------------------------------------

  const items = state.current.children?.length
    ? state.current.children
    : state.parent?.children || [];

  items.forEach((item) => {
    if (item === state.current) return; // avoid duplication

    const li = document.createElement("li");
    li.className = "sz-sidebar__item";

    /* const a = document.createElement("a");
    a.href = item.url;
    a.textContent = item.label;
    a.className = "sz-sidebar__link";

    if (state.path.includes(item.url)) {
      a.classList.add("is-active");
    } */
    const a = createNavLink({
      url: item.url,
      label: item.label,
      className: "sz-sidebar__link",
      isActive: state.path.includes(item.url),
    });

    li.appendChild(a);
    ul.appendChild(li);
  });

  sidebar.replaceChildren(ul);
}
